import { MapStyle, MapStyleConfig } from 'src/components/map-new/types'

export const MAPBOX_TOKEN =
  (process.env.MAPBOX_TOKEN as string) ??
  'pk.eyJ1IjoiYWxwaGFtYXAiLCJhIjoiY2w5Y3VjdTRpMWtnazN1bnRkbHc2eGs1dSJ9.cHqkzAqg131NcHqAdkrCeQ'

export const MAPBOX_STYLES = {
  [MapStyle.STREETS]: 'mapbox://styles/alphamap/cluk290xa00is01nthazg2oou',
  [MapStyle.SATELLITE]: 'mapbox://styles/alphamap/cluk27gas00q301pe9xeq5bhc',
  [MapStyle.LIGHT]: 'mapbox://styles/alphamap/cluk238az00q101peau3zd1ox',
  [MapStyle.DARK]: 'mapbox://styles/alphamap/cluk2599v012g01pi5g72dwl2',

  // Experimental
  [MapStyle.THREEDSATELLITE]: 'mapbox://styles/mapbox/dark-v11',
  [MapStyle.EXP1]: 'mapbox://styles/alphamap/cltd9vobr001e01qr6prg9vlm',
  [MapStyle.EXP2]: 'mapbox://styles/alphamap/clteln4e1002u01qwczya8op9',
  [MapStyle.EXP3]: 'mapbox://styles/alphamap/cltelzf5d002x01qwd8atb01a',
  [MapStyle.MAPBOX]: 'mapbox://styles/mapbox/standard',
}

export const MAP_DEFAULT_STYLE = MapStyle.STREETS
export const MAP_DEFAULT_EDITOR_STYLE = MapStyle.STREETS
export const MAP_DEFAULT_STYLE_CONFIG: MapStyleConfig = {
  showPlaces: true,
  showPlaceLabels: true,
  showRoadLabels: true,
  showHighwayIdentifiers: true,
  showTransportationLabels: true,
  showNaturalFeatures: true,
}

export const MAP_DEFAULT_STYLE_NAMES: Record<keyof MapStyleConfig, string> = {
  showPlaces: 'POI Pins',
  showPlaceLabels: 'Place Labels',
  showRoadLabels: 'Road Names',
  showHighwayIdentifiers: 'Highway Identifiers',
  showTransportationLabels: 'Transportation Labels',
  showNaturalFeatures: 'Natural Features',
}

export const MAP_DEFAULT_WIDTH = '100%'
export const MAP_DEFAULT_HEIGHT = '100%'
export const MAP_DEFAULT_CURSOR = 'grab'
export const MAP_DEFAULT_CENTER_POINT = [-97.7383476477957, 30.237621629711796]
export const MAP_DEFAULT_EDITOR_ZOOM = 12
export const MAP_DEFAULT_ZOOM = 15
export const MAP_DEFAULT_PITCH = 0
export const MAP_DEFAULT_BEARING = 0
export const MAP_DEFAULT_CONTROLS = true

export const MAP_CONTROL_ZOOM_BTN_STEP = 1
export const MAP_CONTROL_ZOOM_BTN_DURATION = 1000
export const MAP_CONTROL_ZOOM_MIN = 0
export const MAP_CONTROL_ZOOM_MAX = 22

export const MAP_DEFAULT_SYNC_DEBOUNCE = 500

export const MAP_EDITABLE_OVERLAY_STYLE = {
  showPlaces: false,
  showPlaceLabels: false,
  showRoadLabels: true,
  showHighwayIdentifiers: true,
  showTransportationLabels: false,
  showNaturalFeatures: false,
}
